import { GETALLCUSTOMERCREATEDAPPOINMENT } from "../utils/api"
import axios from "../utils/axios"

export const getAll = async (payload, callback) => {
    await axios.post(GETALLCUSTOMERCREATEDAPPOINMENT, payload).then((res) => {
        callback(res)
    }).catch((err) => {
        console.log("res ", err)
    })
    return
}